import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import type { ITooltipAngularComp } from 'ag-grid-angular';
import type { ITooltipParams } from 'ag-grid-community';

@Component({
    standalone: true,
    imports: [CommonModule],
    template: ` <div class="custom-tooltip" style="background-color: #fff; width: 600px; padding: 0px;
    border: solid #ccc 1px; max-height: 300px; overflow-y: auto">
        
        <div style="padding: 8px 0 8px 10px;"><b>Modified Data:</b></div>
        <div class="table-responsive-sm">
            <table class="table table-striped table-bordered mb-0" *ngIf="modified_data_arr.length">
                <tbody>
                    <tr class="table-light" *ngFor="let item of modified_data_arr">
                        <td style="padding: 3px 5px 3px 10px; font-weight: 500">{{item.label}}</td>
                        <td style="padding: 3px 10px 3px 5px" *ngIf="isObject(item.value)">{{stringify(item.value)}}</td>
                        <td style="padding: 3px 10px 3px 5px" *ngIf="!isObject(item.value)">{{item.value}}</td>
                    </tr>
                </tbody>
            </table>
        </div>  
    </div>`,
    styles: [
        `
            // :host {
            //     position: absolute;
            //     pointer-events: none;
            //     transition: opacity 1s;
            // }

            // :host.ag-tooltip-hiding {
            //     opacity: 0;
            // }

            // .custom-tooltip p {
            //     margin: 5px;
            //     white-space: nowrap;
            // }

            // .custom-tooltip p:first-of-type {
            //     font-weight: bold;
            // }
        `,
    ],
})
export class AulogsTooltip implements ITooltipAngularComp {
    params!: { color: string } & ITooltipParams;
    modified_data: any;
    modified_data_arr: Array<any>;

    agInit(params: { color: string } & ITooltipParams): void {
        this.modified_data = params.data?.modified_data ? params.data?.modified_data : '';
        const partner_name = params.data?.partner_name;
        this.modified_data_arr = [];
        this.modified_data_arr.push(
            {
                label: 'csp_name',
                value: partner_name ? partner_name : ''
            });
        if (Object.keys(this.modified_data).length) {
            for (const [key, value] of Object.entries(this.modified_data)) {
                let label = `${key}`;
                const val = value == null ? '' : (typeof value === 'object') ? value : `${value}`;
                if (this.lablesToPass(label)) {
                    label = (label === 'partner_name') ? 'csp_name' : label;
                    this.modified_data_arr.push(
                        {
                            label: label ? label : '',
                            value: val ? val : ''
                        }
                    )
                }

            }
        }
    }

    lablesToPass(label: string) {
        return label !== 'app_id'
            && label !== 'partner_id'
            // && label !== 'tier_id'
            && label !== 'vendor_id'
    }

    isObject(value: any) {
        return typeof value === 'object' && value !== null;
    }

    stringify(value: any) {
        return JSON.stringify(value);
    }
}